import { render, staticRenderFns } from "./WebhookHistorical.vue?vue&type=template&id=84a69b0c&scoped=true"
import script from "./WebhookHistorical.vue?vue&type=script&lang=js"
export * from "./WebhookHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a69b0c",
  null
  
)

export default component.exports